import { Box } from '@mui/material';
import { ReactElement } from 'react';
import OverallMaturityScore from './OverallMaturityScore';
import SectionBreakdown from './SectionBreakdown';
import AssessmentHistory from './AssessmentHistory';

const AIRiskBaselineDashboard = ({
  completedAssessment,
  inProgressAssessment,
  completedPage,
  completedTotalPages,
  setCompletedPage,
  inProgressPage,
  inProgressTotalPages,
  setInProgressPage,
  overviewData,
  handleGetInProgress,
}: any): ReactElement => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
    {overviewData && (
      <>
        {/* Overall Maturity Score */}
        <OverallMaturityScore overviewData={overviewData} />

        {/* Section Breakdown */}
        <SectionBreakdown overviewData={overviewData} />
      </>
    )}

    {/* Assessment History */}
    <AssessmentHistory
      completedAssessment={completedAssessment}
      inProgressAssessment={inProgressAssessment}
      completedPage={completedPage}
      completedTotalPages={completedTotalPages}
      onCompletedPageChange={setCompletedPage}
      inProgressPage={inProgressPage}
      inProgressTotalPages={inProgressTotalPages}
      onInProgressPageChange={setInProgressPage}
      handleGetInProgress={handleGetInProgress}
    />
  </Box>
);

export default AIRiskBaselineDashboard;
